import { InvestorHoldingRes, SecurityIssuedIn } from '@dealstack/shared/lib/generated';
import { InvestorHoldingRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/investorHoldings.types.ts';

export const canExpandVesting = (row: InvestorHoldingRow): boolean =>
	row.isSubjectToVesting && !!row.heldForInvestorId;

export const mapHoldingsToRows = ({
	holdings,
}: {
	holdings: InvestorHoldingRes[] | undefined;
}): InvestorHoldingRow[] =>
	(holdings ?? []).map((holding) => ({
		id: `${holding.holderId}-${holding.securityId}-${holding.transactionId}`,
		issuerName: holding.issuerName ?? '',
		issuerId: holding.issuerId ?? '',
		holderId: holding.holderId,
		investmentProgrammeId: holding.investmentProgrammeId,
		securityId: holding.securityId,
		securityName: holding.securityName,
		securityType: holding.securityType,
		// "Directly" for the investor's own rows, the vehicle's name otherwise.
		heldViaName: holding.isViaVehicle ? holding.holderName : null,
		heldForName: holding.heldForName,
		heldForInvestorId: holding.heldForInvestorId,
		units: holding.units,
		totalCostActual: holding.cost,
		totalCostAverage: holding.averageAcquisitionTotalCost,
		actualCostPerUnit: holding.actualCostPerUnit,
		avgCostPerUnit: holding.averageAcquisitionCostPerUnit,
		currentValue: holding.currentValue,
		isSubjectToVesting: holding.isSubjectToVesting,
		transactionCount: holding.transactionCount,
		isIssuedInCurrency: holding.securityIssuedIn === SecurityIssuedIn.CURRENCY,
		currency: holding.currency,
	}));

/** Rows are grouped by issuer, then by security, so an investor's assets read together. */
export const sortHoldingRows = (rows: InvestorHoldingRow[]): InvestorHoldingRow[] =>
	[...rows].sort(
		(a, b) =>
			a.issuerName.localeCompare(b.issuerName) ||
			a.securityName.localeCompare(b.securityName) ||
			(a.heldViaName ?? '').localeCompare(b.heldViaName ?? '') ||
			(a.heldForName ?? '').localeCompare(b.heldForName ?? '')
	);

export const toHoldingRows = (
	payload: { holdings: InvestorHoldingRes[] } | undefined
): InvestorHoldingRow[] =>
	payload ? sortHoldingRows(mapHoldingsToRows({ holdings: payload.holdings })) : [];
